<div class="container-full bg-gradient">
    <div class="bg-skyline">
        <div [ngClass]="{'affiliate_logo': getAffiliate() != null && getAffiliate().anonym == false}">
            <img src="assets/logo-inline-alpha.png" class="logo"/>
            <img *ngIf="getAffiliate() != null && getAffiliate().anonym == false" src="{{ getAffiliate().picture }}" class="logo {{ getAffiliate().code.toLowerCase() }}" style="{{ getAffiliate().picture_style }}"/>
        </div>
        <form [formGroup]="registerForm" (ngSubmit)="onSubmit()">
            <mat-card id="registerForm">
                <a [routerLink]="['/app/register']" class="free-trial message alert-primary">
                    <i class="fa fa-clock-o"></i>
                    Inscrivez vous et profitez de <b>toutes les fonctionnalités</b> de LyBox gratuitement pendant <b>7 jours !</b>
                </a>
                <a [routerLink]="['/app/register']" *ngIf="getAffiliate() != null && getAffiliate().anonym == false && getAffiliate().discount > 0
                    && getAffiliate().code != 'TONY' && getAffiliate().code != 'JM' && getAffiliate().code != 'PAULINE' && getAffiliate().code != 'THEO'"
                   class="free-trial message alert-success mt-3">
                    <i class="fa fa-euro"></i>
                    Grâce à {{ getAffiliate().name }}, vous bénéficiez de <b>-{{ getAffiliate().discount }}% de remise {{ getAffiliate().condition }} sur tous les abonnements LyBox !</b>
                </a>

                <a [routerLink]="['/app/register']" *ngIf="getAffiliate() != null && getAffiliate().anonym == true && getAffiliate().discount > 0" class="free-trial message alert-success mt-3">
                    <i class="fa fa-euro"></i>
                    Grâce à notre partenaire, vous bénéficiez de <b>-{{ getAffiliate().discount }}% de remise {{ getAffiliate().condition }} sur tous les abonnements LyBox !</b>
                </a>

                <a [routerLink]="['/app/register']" *ngIf="getAffiliate() != null && getAffiliate().anonym == false
                    && (getAffiliate().code == 'TONY' || getAffiliate().code == 'JM' || getAffiliate().code == 'PAULINE' || getAffiliate().code == 'THEO')"
                   class="free-trial message alert-success mt-3">
                    <i class="fa fa-euro"></i>
                    Grâce à {{ getAffiliate().name }}, vous bénéficiez <b>d'un mois offert sur tous les abonnements LyBox !</b>
                </a>

                <mat-card-header>
                    <mat-card-title>Inscription</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <app-alert></app-alert>
                    <div class="row mb-5">
                    <div class="col-md-6">
                        <a class="btn btn-facebook" (click)="signInWithFB()">
                            <i class="fa fa-facebook-official" aria-hidden="true"></i>
                            S'inscrire
                        </a>
                    </div>
                    <div class="col-md-6">
                        <a class="btn btn-google" (click)="signInWithGoogle()">
                            <img src="/assets/Google_icon-icons.com_66793.png"/>
                            S'inscrire
                        </a>
                    </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <mat-form-field>
                                    <mat-label>Prénom</mat-label>
                                    <input matInput formControlName="firstName" placeholder="Prénom" class="text">
                                    <mat-error
                                        *ngIf="registerForm.get('firstName').invalid">{{formService.getErrorMessage(registerForm.get('firstName'))}}</mat-error>
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <mat-form-field>
                                    <mat-label>Nom</mat-label>
                                    <input matInput formControlName="lastName" placeholder="Nom" class="text">
                                    <mat-error
                                        *ngIf="registerForm.get('lastName').invalid">{{formService.getErrorMessage(registerForm.get('lastName'))}}</mat-error>
                                </mat-form-field>
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <mat-form-field>
                            <mat-label>E-mail</mat-label>
                            <input matInput formControlName="username" placeholder="E-mail" class="text">
                            <mat-error
                                *ngIf="registerForm.get('username').invalid">{{formService.getErrorMessage(registerForm.get('username'))}}</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="form-group">
                        <mat-form-field>
                            <mat-label>Mot de passe</mat-label>
                            <input matInput formControlName="text_password" [type]="hide ? 'password' : 'text'"
                                   class="text">
                            <p mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'"
                               [attr.aria-pressed]="hide">
                                <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                            </p>
                            <!--                            <mat-hint><a href="#">Mot de passe oublié</a></mat-hint>-->
                            <mat-error
                                *ngIf="registerForm.get('text_password').invalid">{{formService.getErrorMessage(registerForm.get('text_password'))}}</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="form-group" [hidden]="getAffiliate() != null">
                        <mat-form-field>
                            <mat-label *ngIf="!affiliate">Code de parrainage / promotionnel</mat-label>
                            <mat-label *ngIf="affiliate">Partenaire</mat-label>
                            <input matInput formControlName="parainage" type="text" class="text">
                            <mat-error
                                *ngIf="registerForm.get('parainage').invalid">{{formService.getErrorMessage(registerForm.get('parainage'))}}</mat-error>
                        </mat-form-field>
                    </div>

                    <div class="text-center mb-3">
                        <small>En m'inscrivant, je déclare avoir pris connaissance des <a href="https://www.lybox.fr/cgu" target="_blank">conditions générales d’utilisation</a> du site internet et les accepter.</small>
                    </div>

                </mat-card-content>
                <mat-card-actions>
                    <div class="row">
                        <div class="col-6">
                            <a [routerLink]="['/app/login']" [queryParams]="{returnUrl: returnUrl}"
                               class="btn"><- Retour</a>
                        </div>
                        <button class="col-6 btn btn-primary" [disabled]="registerForm.invalid">
                            <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
                            Valider
                        </button>
                    </div>
                </mat-card-actions>
            </mat-card>
        </form>
    </div>
    <div class="bg-sidelogin">
        <div id="picturesCarousel" class="carousel slide" data-ride="carousel">
            <div class="carousel-inner">
                <div class="carousel-item active">
                    <h2>Accélérez votre recherche sur les grands sites immobiliers</h2>
                    <img src="https://www.lybox.fr/build/images/laptop_extension.png.webp"/>
                    <h3>Télécharger notre extension :</h3>
                    <a href="https://chrome.google.com/webstore/detail/lybox/fehddomeihmmofmglpfbdnippnpeoplb"
                       class="btn btn-outline-light">
                        <img src="https://www.lybox.fr/build/images/chrome.png" alt="icon"> Google chrome
                    </a>
                    <a href="https://addons.mozilla.org/en-US/firefox/addon/lybox/" class="btn btn-outline-light">
                        <img src="https://www.lybox.fr/build/images/firefox.png" alt="icon">Mozilla firefox
                    </a>
                </div>
                <div class="carousel-item">
                    <h2>Toute les annonces de plus de 700 sites en un seul</h2>
                    <img src="https://www.lybox.fr/build/images/website-to-lybox.png.webp"/>
                    <a href="https://www.lybox.fr/build/images/website-to-lybox.png.web" class="btn btn-info">
                        Tester notre moteur de recherche
                    </a>
                </div>
                <div class="carousel-item">
                    <h2>Recevez des alertes mails en direct.</h2>
                    <img src="https://www.lybox.fr/build/images/mobile-analyze.svg"/>
                    <img src="https://www.lybox.fr/build/images/svg/mobile-notification.svg" class="notif"/>
                </div>
                <div class="carousel-item">
                    <h2>Simulateur d’investissement locatif integré.</h2>
                    <img src="https://www.lybox.fr/build/images/svg/rendement-graph.svg" class="sim_1" width="350px" />
                    <img src="https://www.lybox.fr/build/images/svg/financement-graph.svg" class="sim_2" width="250px" />
                    <a href="https://www.lybox.fr/app/annonces/new" class="btn btn-info">
                        Commencer un nouveau projet
                    </a>
                </div>
            </div>

            <button class="carousel-control-prev"
                    type="button"
                    [attr.data-bs-target]="'#picturesCarousel'"
                    data-bs-slide="prev">
                <i class="fa fa-chevron-left"></i>
                <span class="visually-hidden">Previous</span>
            </button>
            <button class="carousel-control-next"
                    type="button"
                    [attr.data-bs-target]="'#picturesCarousel'"
                    data-bs-slide="next">
                <i class="fa fa-chevron-right"></i>
                <span class="visually-hidden">Next</span>
            </button>
        </div>
    </div>
</div>
